<template>

  <div v-if="rooms.length == 0">
    Vous n'avez pas encore de chambre de visioconférence
  </div>

  <div v-else>
    <!-- join -->
    <div v-if="false">
      <p class="text-center">
        Rejoindre une chambre
      </p>
      <div>
        <b-button variant="primary" @click="join_room(r.value)" v-for="r in room_options" :key="r.value">{{r.text}}</b-button>
      </div>
    </div>


    <!-- planification -->
    <div class="mt-5">
      <p class="text-center">
        Planifier une visioconférence
      </p>
      <br>
      <b-form>
        <b-row>
          <b-col cols=12 md=1 offset-md=1>
            Date
          </b-col>
          <b-col cols=12 md=2>
            <v-date-picker v-model='date'/>
          </b-col>
          <b-col cols=12 md=1>
            Heure de début
          </b-col>
          <b-col cols=12 md=1>
            <b-form-input type="time" v-model="time_start"></b-form-input>
          </b-col>
          <b-col cols=12 md=1>
            Heure de fin
          </b-col>
          <b-col cols=12 md=1>
            <b-form-input type="time" v-model="time_end"></b-form-input>
          </b-col>
        </b-row>

        <b-row class="mt-1">
          <b-col cols=12 md=1 offset-md=1>
            Chambre
          </b-col>
          <b-col cols=12 md=6>
            <b-form-radio-group v-model="selected_room" :options="room_options" buttons button-variant="outline-primary"></b-form-radio-group>
          </b-col>
        </b-row>

        <b-row class="mt-1">
          <b-col cols=12 md=1 offset-md=1>
            Participants
          </b-col>
          <b-col cols=12 md=6>
            <input-tag v-model="emails" validate="email" placeholder="Adresse mail des participants"></input-tag>
          </b-col>
        </b-row>

        <b-row class="mt-1">
          <b-col cols=12 md=1 offset-md=1>
            Sujet
          </b-col>
          <b-col cols=12 md=6>
            <b-form-textarea v-model="purpose"></b-form-textarea>
          </b-col>
        </b-row>

        <b-row v-if="true" class="mt-1">
          <b-col cols=12 offset-md=5 md=2>
            <b-button variant="success" block :disabled="disabled_button" @click="schedule_visio">Envoyer les invitations</b-button>
          </b-col>
        </b-row>

        <b-spinner v-else variant="primary" class=text-center></b-spinner>

      </b-form>
    </div>

  </div>
</template>

<script>
    export default {
        data() {
            return {
                selected_room: "",
                rooms: [],
                emails: [],
                date: new Date(),
                purpose: "",
                time_start: "00:00",
                time_end: "00:00",
                is_performing_request: false,
            }
        },

        computed: {
            disabled_button() {
                return !this.is_valid_form || this.is_performing_request
            },

            room_options() {
                return this.rooms.map(room => { return {
                    text: `${room.name} (${room.max_participant} participants max)`,
                    value: room.name,
                }})
            },

            is_valid_form() {
                const now = this.$moment()
                const selected_date = this.$moment(this.date)

                return (this.date != null) // date séléctionnée
                    && (this.date >= now.startOf('day')) // la date doit être supérieur à aujourd'hui 00:00
                    && (this.selected_room.length > 0) // une chambre de séléctionnée
                    && (this.emails.length > 0) // au moins un participant
                    && (this.time_start.length > 0) // heure de début séléctionnée
                    && (this.time_end.length > 0) // heure de fin séléctionnée
                    && (this.time_start < this.time_end) // heure de début < heure de fin
                    && (this.purpose.length > 0)
                    && (this.time_start > this.$moment().format("HH:mm") || selected_date > this.$moment())
            },
        },

        methods: {

            async join_room(room_name) {
                console.log(room_name)
            },

            async schedule_visio() {
                if (this.is_valid_form) {

                    const regExp = /(?<hours>\d{2}):(?<minutes>\d{2})/
                    const selected_date = this.$moment(this.date)

                    const match_time_start = this.time_start.match(regExp)
                    const start_timestamp = this.$moment(selected_date).hours(match_time_start.groups.hours).minutes(match_time_start.groups.minutes).seconds(0).unix()

                    const match_time_end = this.time_end.match(regExp)
                    const end_timestamp = this.$moment(selected_date).hours(match_time_end.groups.hours).minutes(match_time_end.groups.minutes).seconds(0).unix()


                    try {
                        this.is_performing_request = true
                        await this.axios.post(`${window.location.origin}/api/visio/schedule_visio`, {
                            room_name: this.selected_room,
                            participants: this.emails,
                            start_timestamp: start_timestamp,
                            end_timestamp: end_timestamp,
                            purpose: this.purpose,
                        })

                        this.$bvToast.toast('Les invitations ont bien été envoyées', {
                            title: `Success`,
                            variant: "success",
                            solid: true
                        })

                    }
                    catch(error) {
                        console.log(error)
                        this.$bvToast.toast("Une erreur est survenue durant l'envoie des invitations", {
                            title: "Erreur",
                            variant: "danger",
                            solid: true
                        })
                    }
                    finally {
                        this.is_performing_request = false
                    }
                }

            },
        },

        async created() {
            try {
                const response = await this.axios.get(`${window.location.origin}/api/visio/rooms`)
                this.rooms = response.data.rooms

            }
            catch(error) {
                if (error.response && error.response.status === 404) {
                    this.rooms = []
                }
                else {
                    console.error(error)

                }
            }
        }
    }
</script>


<style scoped>
</style>
